import React from 'react';
import PropTypes from 'prop-types';
import {
  PageHeader,
  PageReturn,
  PageTitle,
  ContentStatus,
  PageSubheader,
  PageActions,
  PageDescription,
} from '@studio/legacy-components';
import { format } from 'next/lib/date';
import { ContentStateShape } from 'next/lib/shapes';

import { Name, NameWrapper } from './styled';

export function Header({
  name,
  state,
  published,
  returnUrl,
  createdAt,
  createdByName,
  updatedAt,
  updatedByName,
  renderActions,
  renderBadges,
  title,
}) {
  return (
    <PageHeader>
      <PageDescription>
        <PageTitle>
          <PageReturn to={returnUrl} title={title} />
          <NameWrapper>
            <Name title={name}>{name}</Name>
          </NameWrapper>
          <ContentStatus state={state} published={published} />
          {renderBadges?.()}
        </PageTitle>
        <PageSubheader>
          Created {createdByName ? `by ${createdByName}` : ''} on{' '}
          {format(createdAt, 'MMM D, YYYY')}{' '}
          {updatedAt &&
            `| Updated ${
              updatedByName ? `by ${updatedByName}` : ''
            } on ${format(updatedAt, 'MMM D, YYYY')}`}
        </PageSubheader>
      </PageDescription>
      <PageActions>{renderActions?.()}</PageActions>
    </PageHeader>
  );
}

export const HeaderPropTypes = {
  name: PropTypes.string,
  state: ContentStateShape,
  published: PropTypes.bool,
  returnUrl: PropTypes.string,
  createdAt: PropTypes.number,
  createdByName: PropTypes.string,
  updatedAt: PropTypes.number,
  updatedByName: PropTypes.string,
  renderActions: PropTypes.func,
  renderBadges: PropTypes.func,
  title: PropTypes.string,
};

Header.propTypes = HeaderPropTypes;

export default Header;
